import { ChangeDetectionStrategy, Component, ElementRef, HostBinding, Input, ViewChild } from '@angular/core';

import { LogoutConfig } from '@hdms/shared/data-access';
import { HeaderUserService } from '@hdms/shared/page-frame/data-access';
import { UserAccountData } from '@hdms/shared/page-frame/types';

import { AccountLinksService, MenuStateService } from '../../../services';

@Component({
  selector: 'shrd-pf-ft-user-popover-content',
  templateUrl: './user-popover-content.component.html',
  styleUrls: ['./user-popover-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserPopoverContentComponent {
  showAccountSelection = false;

  readonly accountLinks$ = this.accountLinksService.accountLinks$;

  @Input() userData: UserAccountData;
  @Input() logoutConfig: LogoutConfig;

  @ViewChild('rightPanelContent') private readonly rightPanelContent: ElementRef;
  @HostBinding('class.position-relative') private readonly hostClass = true;

  constructor(
    private readonly headerUserService: HeaderUserService,
    private readonly accountLinksService: AccountLinksService,
    private readonly menuStateService: MenuStateService
  ) {}

  toggleAccountSelection(enabled: boolean): void {
    this.showAccountSelection = enabled;
    this.rightPanelContent.nativeElement.scrollTop = 0;
  }

  onAccountChanged(selectedAccountId: string): void {
    this.headerUserService.setSelectedAccount(selectedAccountId);
    this.menuStateService.closeAll();
  }
}
